import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Collapse,
  Row,
  Table,
} from "reactstrap";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
// componentes
import Pagination from "../../../components/Paginationv3";
import WaitExport from "../../../components/WaitExport";
import SearchFilters from "../../../components/SearchFilters";
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import LoadingSkelentonTable from "../../../components/loadingSkeletonTable";
// service
import { getAllUploadApp } from "../../../utils/services/uploadapp";
// utils
import useDebounce from "../../../utils/hooks/useDebounce";
import { createXlsx } from "./createXlsx";

const columnsFilter = [
  { name: "Nome", value: "loginName", type: "text" },
  { name: "Data de Criação", value: "createdAt", type: "date" },
];

function UploadApp() {
  const location = useLocation();
  const eventId = location.state?.idEvent;
  // state de dados
  const [uploads, setUploads] = useState([]);
  const [loading, setLoading] = useState(false);
  // state de paginação
  const [currentIndex, setCurrentIndex] = useState(1);
  const [countData, setCountData] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  // state de pesquisa
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 300);
  // state de filtros
  const [collapseIsOpen, setCollapseIsOpen] = useState(false);
  const [activeFilter, setActiveFilter] = useState("loginName");
  // state de exportação
  const [exportInProgress, setExportInProgress] = useState(false);
  const [finishExport, setFinishExport] = useState(false);
  // state do collapse de opções (mobile)
  const [isOpen, setIsOpen] = useState(false);

  // troca a coluna do filtro e limpa a pesquisa
  function setActiveFilterHandle(columnActive) {
    setActiveFilter(columnActive);
    setSearch("");
  }

  // converte a data de dd/mm/aaaa para aaaa-mm-dd quando o filtro é de data
  const reverseDate = () => {
    const reverse = debouncedSearch
      .split("/")
      .reverse()
      .join("/")
      .replace(/\//g, "-");
    return reverse;
  };

  // devolve o termo de pesquisa no formato esperado pela coluna filtrada
  function treatmentSearch() {
    if (
      columnsFilter.find((item) => item.value === activeFilter)?.type === "date"
    ) {
      return reverseDate();
    }
    return debouncedSearch;
  }

  // atualiza a pesquisa e volta para a primeira página
  function handleSearch(value) {
    setSearch(value);
    setCurrentIndex(1);
  }

  // copia o link do arquivo para a área de transferência
  async function clipBoard(url) {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("O link foi copiado para a área de transferência");
    } catch (error) {
      toast.error("Erro ao copiar o link.");
    }
  }

  // inicia a exportação dos uploads em xlsx
  function exportReport() {
    createXlsx({
      eventId,
      limit: 500,
      search,
      totalItems: countData,
      setFinishExport,
      setExportInProgress,
    });
    setExportInProgress(true);
  }

  // formata a data de criação do upload para "DD/MM/AAAA HH:mm:ss"
  const formatDate = (date) => {
    try {
      const formatedDate = date.split("T")[0].split("-").reverse().join("/");
      const formatTime = date.split("T")[1].split(".")[0];

      return `${formatedDate} ${formatTime}`;
    } catch (error) {
      return date;
    }
  };

  useEffect(() => {
    if (!eventId) {
      toast.error("Evento não encontrado. Acesse a tela pelo menu do evento.");
      return;
    }

    // ignora respostas de requisições antigas (página ou pesquisa anterior)
    let ignore = false;

    setLoading(true);
    getAllUploadApp(
      currentIndex,
      itemsPerPage,
      eventId,
      treatmentSearch(),
      activeFilter
    )
      .then((res) => {
        if (ignore) return;

        if (res?.data?.findAllUpload) {
          setUploads(res.data.findAllUpload.data);
          setCountData(res.data.findAllUpload.count);
        } else {
          toast.error("Erro ao buscar uploads.");
        }
      })
      .catch(() => {
        if (!ignore) toast.error("Erro ao buscar uploads.");
      })
      .finally(() => {
        if (!ignore) setLoading(false);
      });

    return () => {
      ignore = true;
    };
  }, [eventId, currentIndex, itemsPerPage, debouncedSearch, activeFilter]);

  return (
    <div>
      <WaitExport
        isOpen={exportInProgress}
        name="Relatório de Uploads"
        preposicao="do"
        finishExport={finishExport}
        setFinishExport={setFinishExport}
        setExportInProgress={setExportInProgress}
      />
      <Card>
        <CardBody>
          <CardTitle>Relatório por Participante</CardTitle>
          <div>
            <Row
              style={{
                display: "flex",
                flexDirection: "row",
                marginBottom: 10,
                width: "50px",
              }}
            >
              <SectionComponent
                sectionName="Filtros"
                setIsOpen={setCollapseIsOpen}
                isOpen={collapseIsOpen}
              />
            </Row>
            <Collapse isOpen={collapseIsOpen}>
              <SearchFilters
                columns={columnsFilter}
                activeFilter={activeFilter}
                setActiveFilterHandle={setActiveFilterHandle}
              />
            </Collapse>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <form
              className="app-search d-none d-lg-block events-input-search"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="position-relative">
                <input
                  type={activeFilter === "createdAt" ? "date" : "text"}
                  value={search}
                  className="form-control"
                  placeholder="Pesquisar..."
                  onChange={(e) => handleSearch(e.target.value)}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>
            <div className="mobile-btn-section" style={{ width: "100%" }}>
              <Row className="mobile-btns-top">
                <form
                  className="app-search"
                  style={{ padding: "0px" }}
                  onSubmit={(e) => e.preventDefault()}
                >
                  <div className="position-relative">
                    <input
                      type={activeFilter === "createdAt" ? "date" : "text"}
                      value={search}
                      className="form-control"
                      placeholder="Pesquisar..."
                      onChange={(e) => handleSearch(e.target.value)}
                    />
                    <span className="bx bx-search-alt" />
                  </div>
                </form>
              </Row>

              {uploads.length > 0 && (
                <>
                  <SectionComponent
                    sectionName="Opções"
                    setIsOpen={setIsOpen}
                    isOpen={isOpen}
                  />

                  <Collapse isOpen={isOpen}>
                    <Row className="mobile-btns-top">
                      <div onClick={() => exportReport()}>
                        Exportar Relatório
                      </div>
                    </Row>
                  </Collapse>
                </>
              )}
            </div>

            <div className="header-btns-container">
              {uploads.length > 0 && (
                <Button
                  color="success"
                  className="btn-rounded waves-effect waves-light events-button-add"
                  onClick={() => exportReport()}
                >
                  Exportar Relatório
                </Button>
              )}
            </div>
          </div>
          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light">
                <tr>
                  <th>Participante</th>
                  <th>Data de Criação</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <LoadingSkelentonTable lines={10} cols={3} />
                ) : (
                  uploads.map((up) => (
                    <tr key={up.id}>
                      <td>{up.loginName}</td>
                      <td>{formatDate(up.createdAt)}</td>
                      <td>
                        <i
                          role="button"
                          title="Copiar link"
                          className="mdi mdi-content-copy text-secondary font-size-17 mx-1"
                          onClick={() => clipBoard(up.url)}
                        />
                        <a
                          href={up.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          title="Abrir Arquivo"
                        >
                          <i className="mdi mdi-location-enter text-primary font-size-17 mx-1" />
                        </a>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
      <div className="bottom-navigation" style={{ justifyContent: "end" }}>
        <Pagination
          data={uploads}
          currentIndex={currentIndex}
          setCurrentIndex={setCurrentIndex}
          countData={countData}
          maxItemPerPage={itemsPerPage}
          setMaxItemPerPage={setItemsPerPage}
          maxPageButtonsToShow={3}
        />
      </div>
    </div>
  );
}

export default UploadApp;
